import { useQueryClient } from '@tanstack/react-query';

import { useCommunityActionBase } from './useCommunityActionBase';
import { SCHEDULED_POSTS_QUERY_KEY } from './useCommunityScheduledPosts';

// A refused delete reloads the queue too: the post may have started publishing after the queue loaded.
const useDeleteCommunityScheduledPostMutation = () => {
  const queryClient = useQueryClient();

  return useCommunityActionBase<string>({
    buildRequest: (scheduledPostId) => ({
      path: '/delete_community_scheduled_post',
      fields: { scheduled_post_id: scheduledPostId },
    }),
    onSettled: () => queryClient.invalidateQueries({ queryKey: SCHEDULED_POSTS_QUERY_KEY }),
  });
};

export default useDeleteCommunityScheduledPostMutation;
